var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import _objectSpread from "/Users/natebosscher1/Sites/terrain-group/webapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { APIBase } from "nate-react-api-helpers/lib/APIBase";
import { EmployeeAPI } from "./Employees";
import { ProjectAPI } from "./Projects";
import { CustomerAPI } from "./Customers";
import { CostingAPI } from "./Costing";
import { AuditAPI } from "./Audit";
import { LabourCostAPI } from "./LabourCosting";
import { CostSummary } from "./CostSummary";
import { ProjectInvoiceAPI } from "./ProjectInvoice";
import { OverheadAPI } from "./Overhead";
import { VehiclesAPI } from "./Vehicles";
import { EquipmentAPI } from "./Equipment";
import { TimeSheetAPI } from "./TimeSheet";
import { EquipmentCostAPI } from "./EquipmentCosting";
import { VehicleCostAPI } from "./VehicleCosting";
import { InboxAPI } from "./Inbox";
import { MobileBlastAPI } from "./MobileBlast";
import { DocumentAPI } from "./Document";
import { ProjectNotesAPI } from "./ProjectNotes";
import { PayrollAPI } from "./Payroll";
import { ServiceRecordsAPI } from "./ServiceRecords";
import { ReportsAPI } from "./Reports";
import { ServiceRequestsAPI } from "./ServiceRequests";
import { TrackingAPI } from "./Tracking";
import { FormConfigAPI } from "./FormConfig";
import { FormSubmissionAPI } from "./FormSubmission";
import { PrintAPI } from "./Print";
import { ChatAPI } from "./ChatAPI";
import { TaskAPI } from "./Task";
var API = /** @class */ (function (_super) {
    __extends(API, _super);
    function API() {
        var _this = _super.call(this, { jwtRefreshEndpoint: "/api/auth/refresh" }) || this;
        _this.audit = new AuditAPI(_this);
        _this.chat = new ChatAPI(_this);
        _this.contractorsCost = new CostingAPI("contractors", _this);
        _this.costSummary = new CostSummary(_this);
        _this.customers = new CustomerAPI(_this);
        _this.document = new DocumentAPI(_this);
        _this.employees = new EmployeeAPI(_this);
        _this.equipment = new EquipmentAPI(_this);
        _this.equipmentCost = new EquipmentCostAPI(_this);
        _this.formConfig = new FormConfigAPI(_this);
        _this.formSubmission = new FormSubmissionAPI(_this);
        _this.inbox = new InboxAPI(_this);
        _this.labourCost = new LabourCostAPI(_this);
        _this.materialCost = new CostingAPI("materials", _this);
        _this.mobileBlast = new MobileBlastAPI(_this);
        _this.overhead = new OverheadAPI(_this);
        _this.payroll = new PayrollAPI(_this);
        _this.projectInvoices = new ProjectInvoiceAPI(_this);
        _this.projectNotes = new ProjectNotesAPI(_this);
        _this.projects = new ProjectAPI(_this);
        _this.rentalCost = new CostingAPI("rentals", _this);
        _this.reports = new ReportsAPI(_this);
        _this.serviceRecords = new ServiceRecordsAPI(_this);
        _this.serviceRequests = new ServiceRequestsAPI(_this);
        _this.task = new TaskAPI(_this);
        _this.timeSheets = new TimeSheetAPI(_this);
        _this.tracking = new TrackingAPI(_this);
        _this.vehicleCost = new VehicleCostAPI(_this);
        _this.vehicles = new VehiclesAPI(_this);
        _this.print = new PrintAPI(_this);
        _this.bearerToken = null;
        var s = new URLSearchParams(window.location.search);
        _this.bearerToken = s.get("tk");
        _this.fetcher.defaultHeaders.set("X-Source", "web");
        _this.fetcher.defaultHeaders.set("X-APIVersion", "1.0");
        _this.fetcher.preflight.push(function (input) { var headers = new Headers(input.params.headers); headers.set("X-Nonce", window.crypto.randomUUID()); if (_this.bearerToken) {
            headers.set("Authorization", "Bearer ".concat(_this.bearerToken));
        } return _objectSpread(_objectSpread({}, input), {}, { params: _objectSpread(_objectSpread({}, input.params), {}, { headers: headers }) }); });
        return _this;
    }
    API.prototype.ping = function () { return this.fetcher.get("/api/ping"); };
    API.prototype.fetchCustomFromServer = function (url) { var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; return this.fetcher.fetch(url, opts); };
    API.prototype.fileUrl = function (id, opts) { var params = new URLSearchParams(); params.set("scale", (opts === null || opts === void 0 ? void 0 : opts.size) || "none"); params.set("id", id.toString()); params.set("type", (opts === null || opts === void 0 ? void 0 : opts.typ) || "inline"); if (opts !== null && opts !== void 0 && opts.redirect)
        params.set("redirect", opts.redirect); return "/api/file?" + params.toString(); };
    API.prototype.getSignedFileLink = function (id) { var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none"; var typ = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "inline"; return this.fetcher.get("/api/file", { scale: size, id: id, type: typ, format: "json-url" }); };
    return API;
}(APIBase));
export { API };
export var api = new API();
